module.exports = __webpack_public_path__ + "images/icons_v2/verified-filled-db51c221.svg";